import * as React from 'react';

import {FeatureGatePageWrapper} from './feature-gate-page-wrapper';

export function SalesQuotaFeatureGate() {
    return (
        <FeatureGatePageWrapper
            header='Simplify your sales goals with quota management'
            subHeader='Assign and track sales quotas to keep your team motivated and accountable throughout the year.'
            bullets={[
                'Set clear expectations for your team with tailored quotas, helping everyone focus on closing deals and achieving targets.',
                'Distribute quotas evenly among team members, ensuring each person knows their goals, which fosters collaboration and team spirit.',
                'Upgrade to access insights into individual performance, enabling you to provide targeted support and enhance overall team effectiveness.',
            ]}
            feature='salesQuotas'
        />
    );
}
